export default {
  background_image: 'Imagem de fundo',
  file_too_large: 'O ficheiro é demasiado grande. O tamanho máximo é {{max}} MB.',
  upload_failed: 'Falha no carregamento. Tente novamente.',
};
